export default getTrackLang;

const options = [
  getLang,
  extractLang,
  remapLegacyLang
];

/**
 *
 * @param {AudioTrack} track
 * @return {string} lang
 */
function getTrackLang(track) {
  for (let i = 0; i < options.length; i++) {
    const lang = options[i](track);
    if (lang && lang.length === 2) {
      return lang;
    }
  }
  throw new Error('Unresolved language');
}

function getLang({ lang_iso_639_1 }) {
  return lang_iso_639_1;
}

function extractLang({ lang_tag = '' }) {
  return lang_tag.slice(0, 2);
}

/**
 * Similar, but not equal, exist in mgg-epg, the only one more clone
 * and I must create a package.
 */
function remapLegacyLang({ lang }) {
  const langMap = new Map([
    [ 'ua', 'uk' ], // uk-UA
    [ 'ee', 'et' ], // et-EE
    [ 'kz', 'kk' ], // kk-KZ
    [ 'ge', 'ka' ], // ka-GE
    [ 'kg', 'ky' ], // ky-KG
  ]);
  return langMap.get(lang);
}
